// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setBillingActivityLogList,
  setBillingActivityLoader,
  setBillingBatchList,
  setBatchInvoice,
  setBillingInvoiceDetails,
  setBillingInvoiceActivityLog,
  setIsBillingLoad
} from 'src/store/modules/actions/billing'

const initialState = {
  billingActivityLogList: [],
  billingBatchList: [],
  batchInvoice: [],
  invoiceDetails: {},
  invoiceActivityLog: [],
  loader: false,
  isBillingLoad: false
}

export default handleActions(
  {
    [setBillingActivityLogList](state, { payload: billingActivityLogList }) {
      return {
        ...state,
        billingActivityLogList
      }
    },
    [setBillingActivityLoader](state, { payload: loader }) {
      return {
        ...state,
        loader
      }
    },
    [setBillingBatchList](state, { payload: billingBatchList }) {
      return {
        ...state,
        billingBatchList
      }
    },
    [setBatchInvoice](state, { payload: batchInvoice }) {
      return {
        ...state,
        batchInvoice
      }
    },
    [setBillingInvoiceDetails](state, { payload: invoiceDetails }) {
      return {
        ...state,
        invoiceDetails
      }
    },
    [setBillingInvoiceActivityLog](state, { payload: invoiceActivityLog }) {
      return {
        ...state,
        invoiceActivityLog
      }
    },
    [setIsBillingLoad](state, { payload: isBillingLoad }) {
      return {
        ...state,
        isBillingLoad
      }
    }
  },
  initialState
)
